import MenuRecents from './MenuRecents'

export default MenuRecents
